import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import PowerBIReportsSidebar from "./PowerBIReportsSidebarVF";
import Header from "./Header";
import { useLocation } from "react-router-dom";
import { useLocalStorage } from "../useLocalStorage";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { toast } from "react-toastify";

const MainReport = () => {
  const { instance } = useMsal();
  const [embedToken, setEmbedToken] = useState(null);
  const location = useLocation();
  const { workspaceId } = location.state || {};
  const [isSidebarOpen, setIsSidebarOpen] = useLocalStorage('isSidebarOpen',null);
  const [nameReport, setnameReport] = useLocalStorage('nameReport',null);

  const getAccountInfo = () => {
    const accounts = instance.getAllAccounts();
    return accounts.length > 0 ? accounts[0] : null;
  };

  const userAuth = getAccountInfo();

  const user = {
    name: userAuth?.name || "Usuario desconocido",
    email: userAuth?.username || "email@desconocido.com",
  };

  const handleLogout = () => {
    instance.logoutRedirect({
      //postLogoutRedirectUri: "http://localhost:3000",
      postLogoutRedirectUri: "https://analytics.centenario.com.pe", // Cambia esto según tu entorno
    });
  };

  /** Obtiene un nuevo token desde MSAL */
  const fetchToken = async () => {

    if (!userAuth) {
      await instance.loginPopup({
        scopes: ["https://analysis.windows.net/powerbi/api/.default"],
      });
    }

    try {
      const tokenResponse = await instance.acquireTokenSilent({
        scopes: ["https://analysis.windows.net/powerbi/api/.default"],
        account: userAuth,
      });

      setEmbedToken(tokenResponse.accessToken);
    } catch (error) {
      console.error("Error al obtener el token aqui:", error);
    }
  };

  useEffect(() => {
    fetchToken();
    setnameReport('');
    // Configurar intervalo para renovar el token antes de que expire (ejemplo: cada 45 minutos)
    const tokenRefreshInterval = setInterval(() => {
      fetchToken();
    }, 45 * 60 * 1000); // 45 minutos

    return () => clearInterval(tokenRefreshInterval);
  }, [instance, userAuth]);

  useEffect(() => {
    setIsSidebarOpen(true);
    setnameReport('');
    
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        //fetchToken(); // Refrescar token si es necesario al volver a la pestaña
        //window.location.reload();
      }
        
    };
    
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return (
    <div>
      <Header user={user} onLogout={handleLogout} />
      <div style={{ height: "90vh", width: "auto" }}>
        <PowerBIReportsSidebar
          token={embedToken}
          workspaceid={workspaceId}
          user={user}
          onLogout={handleLogout}
          onTokenExpired={fetchToken} // Detecta cuando el token expira y lo renueva
        />
      </div>
    </div>
  );
};

export default MainReport;
